const defaults = {
    freeBasicSample: '.cart-btn',
};

const freeBasicSample = document.querySelector(defaults.freeBasicSample);

/**
 * @param Object items 
 */

/**
 * Sample data to receive
 * {items:[{id:40430674378800, quantity:1, properties: {}}]}
 */
function add(items) {
    fetch('/cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(items)
    })
    .then(response => {
        $('.add_swatches').removeClass(LOADING_CLASS);
        $('.add_swatches').attr('disabled', 'disabled');
        $('.add_swatches .text').text('Swatch added to cart.');
        $('.add_swatches .checkmark').addClass('checkmark-active');
       
        setTimeout(() => {
            $('.add_swatches').removeAttr('disabled');
            $('.add_swatches .text').text('Order your swatches');
        }, 3000)

        //Initiate cart drawer refresh
        const cartDrawer =  document.querySelector('cart-drawer');
        cartDrawer.refresh();

        fetchFreeSample(id = null, action = 'add');
        localStorage.removeItem('_temp_free_sample');
        return response.json();
    })
    .catch((error) => {
        console.error('Error:', error);
    });
}

function fetchFreeSample(id = null, action = null) {
    $.ajax({
        type: 'GET',
        url: '/cart.js',
        dataType: 'json',
        success: function(cart) {
            var items = [];
            const cartCount = cart.item_count > 0 ? cart.item_count : '';
            $.each(cart.items, function(index, product) {
                if(product.properties) {
                    Object.keys(product.properties).forEach(function(key) {
                        if(product.properties[key] === 'Free Fabric Sample') {
                            items.push(product);
                        }

                        return;
                    });
                }
            });

            localStorage.setItem("_free_sample", JSON.stringify(items));
            populateFreeSample();

            if($('.header__cart-icon .header__icons---count').length <= 0) {
                $('.header__cart-icon').append(`<span class="header__icons---count cart_count"></span>`)
            }

            $('.header__cart-icon .header__icons---count').text(cartCount);

            if(id) $(`.swatch-to-show[data-swatch-variant-id="${id}"] .swatch-item 
            `).removeClass('active');
            $('.remove-image-swatch-container, .selected--item').css(ENABLE_STATE);
            $('.add_swatches').removeClass(LOADING_CLASS);

            $('.add_swatches .checkmark').removeClass('checkmark-active');
            $('.add_swatches .text').fadeIn();

            if(action == 'add') $('.close-btn').trigger('click');
            
            checkFreeSample();
        },
    });
}

function remove(id) {
    jQuery.post({
        url:'/cart/update.js',
        type: 'POST',
        dataType: 'json',
        data: `updates[${id}]=0`,
        success: function() {

            //Initiate cart drawer refresh
            const cartDrawer =  document.querySelector('cart-drawer');
            cartDrawer.refresh();

            fetchFreeSample(id, action = 'remove');
        },
        error: function(e) {
            console.log(e)
        }
      })
}

function populateFreeSample() {
    const selectedSwatchArr = JSON.parse(localStorage.getItem("_free_sample")).reverse() || [];
    const tempSelectedSwatchArr = JSON.parse(localStorage.getItem("_temp_free_sample")) || [];
    const data = [...selectedSwatchArr, ...tempSelectedSwatchArr];

    $(`.selected--item`).empty();
    $(`.selected--item`).css('background', 'none');

    if(data) {
        $(`input[name="swatches"]`).prop('checked', false)
        $(`input[name="swatches"]`).removeAttr('disabled')
        $(`input[name="swatches"]`).next('li').removeClass('active')

        data.forEach((value, index) => {
            const title = value.title;
            const image = value.image;
            const smallImage = image
                .replace(/(\.[^/.]+)$/, (match) => {
                    return image.includes('_small') ? match : '_small' + match;  // Adds _small only if not present
                });

            const variantid = value.variant_id || '';
            const swatchIndex = index + 1;
            const _temp_free_sampleClass = value.class || '_free_sample';
            
            $(`input[value=${variantid}]`).prop('checked', true)
            $(`input[value=${variantid}]`).attr('disabled', 'disabled')
            $(`input[value=${variantid}]`).next('li').addClass('active')

            $(`.selected-item-index-${swatchIndex}`).css('background', `url(${smallImage})`);
            $(`.selected-item-index-${swatchIndex}`).attr('title', title)
            $(`.selected-item-index-${swatchIndex}`).append(
                `<div 
                    class="remove-image-swatch-container ${_temp_free_sampleClass}" 
                    data-variant-id='${variantid}'>
                        <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-close" fill="none" viewBox="0 0 18 17">
                        <path d="M.865 15.978a.5.5 0 00.707.707l7.433-7.431 7.579 7.282a.501.501 0 00.846-.37.5.5 0 00-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 10-.707-.708L8.991 7.853 1.413.573a.5.5 0 10-.693.72l7.563 7.268-7.418 7.417z" fill="currentColor">
                        </path></svg>
                </div>`
                );
        });
    }
}

function checkFreeSample() {
    const swatches = $("input:checkbox[name=swatches]:checked");

    if(swatches.length > 0) {
        $('.add_swatches').removeClass('disabled');  
        $('.add_swatches').removeAttr('disabled');  
    } else {
        $('.add_swatches').addClass('disabled');
        $('.add_swatches').attr('disabled', 'disabled');
    }
}

function moveZendeskButton(size = 0) {
    // Move the Zendesk button to the right
    $('iframe#launcher').css('right', `${size}px`);
}

function disableBodyOverScroll() {
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    $('body').css({
        'overflow': 'hidden',
        'padding-right': scrollbarWidth + 'px'
    });
}

function enableBodyOverScroll() {
    $('body').css({
        'overflow': '',
        'padding-right': '0px'
    });
}

function refreshCart(cart) {
    $(".cart_count").empty();
    $cartBtn = $(".cart_count");
    var value = $cartBtn.text() || "0";
    var cart_items_html = "";
    var cart_discounts_html = "";
    var cart_action_html = "";
    var cart_savings_html = "";
    var $cart_form = $("[data-cart-form]");
    var productHasSale = false;
    var productCompareAtPrice = 0;
    var productFinalPrice = 0;
    $cart_form.data("total-discount", cart.total_discount);
    $cartBtn.text(value.replace(/[0-9]+/, cart.item_count));
    if (cart.item_count == 0) {
        $(".js-empty-cart__message").removeClass("hidden");
        $cart_form.addClass("hidden");
    } else {
        $(".js-empty-cart__message").addClass("hidden");
        $cart_form.removeClass("hidden");
        var total_saving = 0;
        var saving = 0;
        $.each(cart.items, function (index, item) {
            var itemDiscounts = item.discounts;
            var discountMessage = "";
            const type = item.properties?._type;
            for (i = 0; i < itemDiscounts.length; i++) {
                var amount = formatMoney(itemDiscounts[i].amount, $("body").data("money-format"));
                var title = itemDiscounts[i].title;
                discountMessage = '<p class="notification-discount meta">' + title + "</p>";
            }
            var line_id = index + 1;
            if(type === 'Free Fabric Sample') {
                cart_items_html += '<li class="mini-cart__item clearfix" data-cart-item data-line-id="' + line_id + '" data-variant-id="' + item.id + '">' + '<a>';
            } else {
                cart_items_html += '<li class="mini-cart__item clearfix" data-cart-item data-line-id="' + line_id + '" data-variant-id="' + item.id + '">' + '<a href="' + item.url + '">';
            }
            if (item.image) {
                cart_items_html += '<div class="cart_image">' + '<img crossorigin="anonymous"  src="' + item.image.replace(/(\.[^.]*)$/, "_compact$1").replace("http:", "") + '" alt="' + item.title + '" />' + "</div></a>";
            }
            if(type === 'Free Fabric Sample') {
                cart_items_html += `<div class="mini-cart__item--content"><div class="mini-cart__item__title"><div class="item_title">${item.title}</div>`;
            } else {
                cart_items_html += '<div class="mini-cart__item--content"><div class="mini-cart__item__title"><div class="item_title"><a href="' + item.url + '">' + item.title + "</a></div>";
            }
            if (item.properties) {
                $.each(item.properties, function (title, value) {
                    if (value && title !== "_expected-dispatch" && title != '_sofa_id' && title != '_type' ) {
                        cart_items_html += '<div class="line-item">' + title + ": " + value + " </div>";
                    }
                });
            }
            cart_items_html += '<div class="right price">';
            if (productHasSale == true) {
                var itemPrice = formatMoney(productFinalPrice, $("body").data("money-format")) + ' </span><span class="money was_price">' + formatMoney(productCompareAtPrice, $("body").data("money-format")) + "</span>";
                cart_items_html += '<span class="money sale">' + itemPrice + "</span></div>";
                saving = (productCompareAtPrice - productFinalPrice) * item.quantity;
                total_saving = saving + total_saving;
            } else {
                if (item.price > item.final_price) {
                    var itemPrice = formatMoney(item.final_price, $("body").data("money-format")) + ' </span><span class="money was_price">' + formatMoney(item.price, $("body").data("money-format")) + "</span>";
                    cart_items_html += '<span class="money sale">' + itemPrice + "</span></div>";
                } else {
                    var itemPrice = formatMoney(item.price, $("body").data("money-format"));
                    cart_items_html += '<span class="money">' + itemPrice + "</span></div>";
                }
            }
            if (item.price > item.final_price) {
                cart_items_html += discountMessage;
            }

            if(type && type == 'Free Fabric Sample') 
                cart_items_html += '<div class="left product-quantity-box hidden">';
            else 
                cart_items_html += '<div class="left product-quantity-box">';
                
            cart_items_html += '<span class="ss-icon product-minus js-change-quantity" data-func="minus"><span id="icon__minus" class="icon-minus"></span></span>';
            cart_items_html += '<input type="number" min="0" class="quantity" name="updates[]" id="updates_' + item.id + '" value="' + item.quantity + '" data-cart-quantity-input="mini-cart" />';
            cart_items_html += '<span class="ss-icon product-plus js-change-quantity" data-func="plus"><span id="icon__plus" class="icon-plus"></span></span>';
            cart_items_html += "</div></div></div>";

            cart_items_html += '<a href="/cart/change?line=' + line_id + '&amp;quantity=0" class="js-cart-remove-btn cart__remove-btn" data-line-id="' + line_id + '" data-remove-item="mini-cart"><span class="remove-icon"></span></a>';
        });
        var cartDiscounts = cart.cart_level_discount_applications;
        var cartDiscountMessage = "";
        if(cartDiscounts) {
            for (i = 0; i < cartDiscounts.length; i++) {
                var amount = formatMoney(cartDiscounts[i].total_allocated_amount, $("body").data("money-format"));
                var title = cartDiscounts[i].title;
                cart_discounts_html += '<span class="cart_discounts--title">' + title + "</span>";
                cart_discounts_html += '<span class="cart_discounts--price">';
                cart_discounts_html += '-<span class="money">' + amount + "</span></span>";
            }
        }
        cart_action_html += '<span class="right"><span class="money">' + formatMoney(cart.total_price, $("body").data("money-format")) + "</span></span>" + "<span>" + Shopify.translation.cart_subtotal_text + "</span>";
        total_saving = total_saving + cart.total_discount;
        if (Shopify.theme_settings.display_savings && total_saving > 0) {
            cart_savings_html = '<span class="right"><span class="money">' + formatMoney(total_saving, $("body").data("money-format")) + "</span></span>" + "<span>" + Shopify.translation.cart_savings_text + "</span>";
        } else {
            cart_savings_html = "";
        }
    }
    $(".js-cart_items").html(cart_items_html);
    $(".js-cart_discounts").html(cart_discounts_html);
    $(".js-cart_subtotal").html(cart_action_html);
    $(".js-cart_savings").html(cart_savings_html);
    if (Currency.show_multiple_currencies) {
        currencyConverter.convertCurrencies();
    }
}